// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { Container, Row, Col } from "react-bootstrap";
// import { setIntervalCart } from "../../reducers/cart";
// import { Link } from "react-router-dom";

// function HeaderTop() {
//   const dispatch = useDispatch();
//   const cart = useSelector((state) => state.cart);
//   const [isInitialRender, setIsInitialRender] = useState(true);

//   useEffect(() => {
//     if (isInitialRender) {
//       setIsInitialRender(false);
//       return;
//     }

//     const cartjsonString = JSON.stringify(cart);
//     localStorage.setItem("cartjsonString", cartjsonString);
//   }, [cart]);

//   useEffect(() => {
//     // If it's the first render
//     const cartjsonString = localStorage.getItem("cartjsonString");
//     if (cartjsonString) {
//       try {

//         const cartjsonObject = JSON.parse(cartjsonString);
//         dispatch(setIntervalCart(cartjsonObject));
//       } catch (error) {

//         dispatch(setIntervalCart({ items: [], totalAmount: 0 }));
//       }
//     }
//   }, []);
//   return (
//     <>
//       <section className="header-top">
//         <Container>
//           <Row className="top-content-wrap">
//             <Col lg={12} sm={12} xs={12} className="text-center">
//               <ul className="m-0 p-0 ">
//                 <li className='py-1 text-center text-white'>
//                   <font size="2">Summer Sale For All Swim Suits And Free Express International Delivery - Off 50%! Shop Now</font>
//                 </li>
//                 {/* <li>
//                 <a href="#" className='text-white text-decoration-none'>
//                   <i className="fa fa-phone"></i> +91 74052 97103
//                 </a>
//               </li> */}
//               </ul>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// }

// export default HeaderTop;

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { setIntervalCart } from "../../reducers/cart";

function HeaderTop() {
    const dispatch = useDispatch();
    const cart = useSelector(state => state.cart);

    useEffect(() => {
        const cartData = sessionStorage.getItem("cart");

        if (!cartData) return;

        try {
            dispatch(setIntervalCart(JSON.parse(cartData)));
        } catch (error) {
            sessionStorage.removeItem("cart");
            dispatch(setIntervalCart({
                items: [],
                totalAmount: 0
            }));
        }
    }, [dispatch]);

    useEffect(() => {
        sessionStorage.setItem("cart", JSON.stringify(cart));
    }, [cart]);

    return (
        <section className="header-top">
            <Container>
                <Row className="top-content-wrap">
                    <Col lg={12} sm={12} xs={12} className="text-center">
                        <ul className="m-0 p-0">
                            <li className="py-1 text-center text-white">
                                <font size="2">
                                    Summer Sale For All Swim Suits And Free Express International Delivery - Off 50%! Shop Now
                                </font>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default HeaderTop;